import React from 'react';

import { SectionLayout } from '../../components/Layouts';

import { HeadlineTitle } from '../../components/Title';
import { Benefit } from '../../components/GraphicBurst';

const Benefits = ({ title, items }) => {
  const images = [
    {
      image: 'graphicBurst1',
    },
    {
      image: 'graphicBurst2',
    },
    {
      image: 'graphicBurst4',
    },
    {
      image: 'graphicBurst7',
    },
  ];
  return (
    <SectionLayout id="get-involved">
      <HeadlineTitle>{title}</HeadlineTitle>

      <Benefit
        image={images[0].image}
        title={(items[0] && items[0].title) || 'first item title...'}
        description={(items[0] && items[0].description) || 'first item description...'}
        mt={6}
        mtT={5}
        mtM={4}
        as="pre"
      />

      <Benefit
        image={images[1].image}
        title={(items[1] && items[1].title) || 'second item title...'}
        description={(items[1] && items[1].description) || 'second item description...'}
        left
        mt={5}
        as="pre"
      />

      <Benefit
        image={images[2].image}
        title={(items[2] && items[2].title) || 'third item title...'}
        description={(items[2] && items[2].description) || 'third item description...'}
        mt={5}
        as="pre"
      />

      <Benefit
        image={images[3].image}
        title={(items[3] && items[3].title) || 'fourth item title...'}
        description={(items[3] && items[3].description) || 'fourth item description...'}
        left
        mt={5}
        as="pre"
      />
    </SectionLayout>
  );
};

export default Benefits;
